import { setAuthDefaults } from "../modules/auth/defaults";
import { setCommonDefaults } from "../modules/common/defaults";

export const setDefaults = () => {
  setCommonDefaults();
  setAuthDefaults();
};
